import React from "react";
import PropTypes from "prop-types";
import tw from "twin.macro";
import config from "../../../gatsby-config.js"

const DocTable = tw.table`w-full block md:table table-fixed overflow-x-scroll mb-4`;
const DocTableHeader = tw.thead`hidden md:table-header-group border-b border-gray-200`;
const DocTableHeading = tw.th`text-left p-2 md:p-4 lg:p-6 bg-gray-50`;
const DocTableHeadingTitle = tw(DocTableHeading)`lg:w-4/12`;
const DocTableHeadingSize = tw(DocTableHeading)`lg:w-1/12`;
const DocTableBody = tw.tbody`divide-y divide-gray-100`;
const DocTableRow = tw.tr`p-4 lg:p-6 block md:table-row bg-gray-50 odd:bg-white`;
const DocTableItem = tw.td`md:p-4 lg:p-6 block md:table-cell`;
const DocTableItemLabel = tw.span`inline text-gray-500 md:hidden`;
const DocLink = tw.a`text-blue-900 hover:text-blue-700 focus:text-blue-700 font-bold`;

const isExternalUrl = url => url.match(/^\/downloads\/.*/)
const formatUrl = url => isExternalUrl(url)  ? formatInternalUrl(url) : url
const formatInternalUrl = url => `${process.env.NODE_ENV == 'development' ? '' : config.pathPrefix}${url}`

const ITEMS_PER_PAGE = 10;

const DocumentLibrary = ({ documents, includeLao }) => {
  const documentsSorted = documents.sort((a,b) => a.title < b.title ? -1 : (a.title > b.title ? 1 : 0))
  const numPages = Math.ceil(documentsSorted.length / ITEMS_PER_PAGE);

  return documents.length == 0 ? <div tw="my-4">No resources match the selected critieria.</div> : (
  <>
    <DocTable>
      <DocTableHeader>
        <tr>
          <DocTableHeadingTitle>Title</DocTableHeadingTitle>
          <DocTableHeading>Category</DocTableHeading>
          {includeLao && <DocTableHeading>LAO</DocTableHeading>}
          <DocTableHeading>Type</DocTableHeading>
          <DocTableHeadingSize>Format</DocTableHeadingSize>
          <DocTableHeadingSize>Size</DocTableHeadingSize>
        </tr>
      </DocTableHeader>
      <DocTableBody>
        {documentsSorted.map((doc,i) => (
          <DocTableRow key={doc.title + i}>
            <DocTableItem>
              <DocTableItemLabel>Title: </DocTableItemLabel>
              <DocLink href={formatUrl(doc.url)}>{doc.title}</DocLink>
            </DocTableItem>
            <DocTableItem>
              <DocTableItemLabel>Category: </DocTableItemLabel>
              {doc.category.join(", ")}
            </DocTableItem>
            {includeLao && <DocTableItem>
              <DocTableItemLabel>LAO: </DocTableItemLabel>
              {doc.lao}
            </DocTableItem>
            }
            <DocTableItem>
              <DocTableItemLabel>Type: </DocTableItemLabel>
              {doc.type}
            </DocTableItem>
            <DocTableItem>
              <DocTableItemLabel>Format: </DocTableItemLabel>
              {doc.format}
            </DocTableItem>
            <DocTableItem>
              <DocTableItemLabel>Size: </DocTableItemLabel>
              {doc.size}
            </DocTableItem>
          </DocTableRow>
        ))}
      </DocTableBody>
    </DocTable>
  </>
)};

DocumentLibrary.propTypes = {
  documents: PropTypes.array,
  includeLao: PropTypes.bool
};

DocumentLibrary.defaultProps = {
  includeLao: false
}

export default DocumentLibrary;
